// Import wizard route for a specific collection
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router';

import { CollectionImportWizard } from '@/features/datahub/collections/CollectionImportWizard';

export const Route = createFileRoute(
  '/_authenticated/datahub/collections/$collectionId/import'
)({
  component: ImportPage,
});

function ImportPage() {
  const { collectionId } = useParams({ strict: false });
  const navigate = useNavigate();

  return (
    <CollectionImportWizard
      collectionId={collectionId ?? ''}
      onComplete={() => void navigate({ to: `/datahub/collections/${collectionId ?? ''}` })}
      onCancel={() => void navigate({ to: `/datahub/collections/${collectionId ?? ''}` })}
    />
  );
}
